import { IError } from 'utils/transformResponseError';

export enum APPROVE_STATUS {
  DRAFT = 'draft',
  WAITING_APPROVE = 'waiting_approve',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  TERMINATED = 'terminated',
}

export enum DOCUMENTS_STATUSES {
  PENDING = 'pending',
  INCOMPLETE = 'incomplete',
  COMPLETED = 'completed',
}

export enum MENU_STATUSES {
  REQUIRED = 'กรุณากรอกข้อมูล',
  PENDING = 'ยังไม่มีข้อมูล',
  SUBMITTED = 'รอตรวจสอบ',
  REJECTED = 'เอกสารไม่ถูกต้อง',
  APPROVED = 'อนุมัติ',
  EXPIRED = 'หมดอายุ',
  START_TRAINING = 'เริ่มต้นการอบรม',
  WAITING = 'รอผลทดสอบ',
  CONFIRM = 'รอยืนยันการอบรม',
}

export enum RIDER_TYPE {
  LOTUS = 'LOTUS',
  CPALL = 'CPALL',
}

export interface IDriverDocumentsReview {
  approveStatus: APPROVE_STATUS;
  documents: IDocument[];
  documentsStatus: DOCUMENTS_STATUSES;
  documentsReviewStatus: IDocumentsReviewStatus;
  documentReviewStatus: IDocumentReviewStatus;
}

export interface IMainResponse {
  data: IDriverDocumentsReview;
}

export interface IUpdateReviewStatusRequest {
  type: 'save';
}

export interface IUpdateReviewStatusResponse {}

export interface IDocument {
  status: string;
  title: string;
  code: string;
  required: boolean;
  path: string;
}

export interface IDocumentsReviewStatus {
  status: string;
  message?: string;
}

export interface IDocumentReviewStatus {
  status: string;
  message?: string;
}

export enum DocumentReviewStatus {
  INCOMPLETE = 'INCOMPLETE',
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
}
interface IDocumentImage {
  image: string;
  createdAt: string;
  isAllowConsent?: boolean;
}

interface IBookBankData {
  status: DocumentReviewStatus;
  rejectReasonCode: string;
  document: IDocumentImage;
  accountNumber: string;
  name: string;
  branch: string;
  accountName: string;
  accountType: string;
  note: string;
  createdAt: string;
  updatedAt: string;
  documentsReviewStatus: IDocumentsReviewStatus;
  documentReviewStatus: IDocumentReviewStatus;
  editedBy: string;
  approveStatus: APPROVE_STATUS;
}

export interface IBookBankResponse {
  data: IBookBankData;
}

interface IVaccinationCertificateData {
  status: DocumentReviewStatus;
  rejectReasonCode: string;
  document: IDocumentImage;
  dose: string;
  note: string;
  createdAt: string;
  updatedAt: string;
  documentsReviewStatus: IDocumentsReviewStatus;
  documentReviewStatus: IDocumentReviewStatus;
  editedBy: string;
  name: string;
  approveStatus: APPROVE_STATUS;
}

export interface IVaccinationCertificateResponse {
  data: IVaccinationCertificateData;
}

interface IOnlineTrainingData {
  status: DocumentReviewStatus;
  trainingVideo: string;
  quiz: string;
  note: string;
  createdAt: string;
  updatedAt: string;
  documentsReviewStatus: IDocumentsReviewStatus;
  documentReviewStatus: IDocumentReviewStatus;
}

export interface IOnlineTrainingResponse {
  data: IOnlineTrainingData;
}

interface IVehicleInsuranceData {
  status: DocumentReviewStatus;
  insuranceDocument: IDocumentImage;
  ownerInsurance: string;
  chassisNumber: string;
  issueDate: string;
  expiryDate: string;
  agreementDate: string;
  policyIssueDate: string;
  documentsReviewStatus: IDocumentsReviewStatus;
  documentReviewStatus: IDocumentReviewStatus;
}

interface IVehicleInformationData {
  status: DocumentReviewStatus;
  rejectReasonCode: string;
  serviceType: string;
  registrationDocument: IDocumentImage;
  plateNumber: string;
  brand: string;
  model: string;
  registrationType: string;
  ownership: string;
  ownerInsurance: string;
  consentFormDocument: IDocumentImage;
  carTaxStickerDocument: IDocumentImage;
  vehicleInsuranceDocument: IDocumentImage;
  documentsReviewStatus: IDocumentsReviewStatus;
  documentReviewStatus: IDocumentReviewStatus;
  editedBy: string;
  approveStatus: APPROVE_STATUS;
  firstname?: string;
  lastname?: string;
  issueDate?: string;
  expiryDate?: string;
  agreementMadeOn?: string;
  policyIssuedOn?: string;
}

export interface IVehicleInformationResponse {
  data: IVehicleInformationData;
}

interface IVoluntaryInsuranceData {
  ownerInsurance?: string;
  status: DocumentReviewStatus;
  rejectReasonCode: string;
  insuranceDocument: IDocumentImage;
  documentsReviewStatus: IDocumentsReviewStatus;
  documentReviewStatus: IDocumentReviewStatus;
  editedBy: string;
  approveStatus: APPROVE_STATUS;
  firstName?: string;
  lastName?: string;
  issueDate?: string;
  expiryDate?: string;
  agreementMadeOn?: string;
  policyIssuedOn?: string;
}

export interface IVoluntaryInsuranceResponse {
  data: IVoluntaryInsuranceData;
}

interface IDriverLicenseData {
  status: DocumentReviewStatus;
  rejectReasonCode: string;
  type: string;
  document: IDocumentImage;
  issueDate: string;
  expiryDate: string;
  note: string;
  createdAt: string;
  updatedAt: string;
  documentsReviewStatus: IDocumentsReviewStatus;
  documentReviewStatus: IDocumentReviewStatus;
  editedBy: string;
  approveStatus: APPROVE_STATUS;
}

export interface IDriverLicenseResponse {
  data: IDriverLicenseData;
}

interface ICitizen {
  id: string;
  issueDate: string;
  expiryDate: string;
}

interface IIdentityData {
  status: DocumentReviewStatus;
  rejectReasonCode: string;
  driverPhotoDocument: IDocumentImage;
  citizenIDDocument: IDocumentImage;
  nameChangeDocument: IDocumentImage;
  birthDate: string;
  citizen: ICitizen;
  note: string;
  createdAt: string;
  updatedAt: string;
  documentsReviewStatus: IDocumentsReviewStatus;
  documentReviewStatus: IDocumentReviewStatus;
  editedBy: string;
  approveStatus: APPROVE_STATUS;
  isAllowCriminalRecord: boolean;
}

export interface IIdentityResponse extends IError {
  data: IIdentityData;
}

export interface IPreferredServiceAreas {
  districtId?: string;
  province?: string;
  district?: string;
  isAllowEmergencyContact: boolean;
}

export interface IPreferredServiceAreasForCPALL {
  districtId?: string;
  province?: string;
  district?: string;
  subDistrict?: string;
  subDistrictId?: string;
  storeCode?: string;
  storeName?: string;
  isAllowEmergencyContact: boolean;
}

export interface ITaxAddress {
  isAddressAccordingToIDCard: boolean;
  address?: string;
  province?: string;
  district?: string;
  subDistrict?: string;
  postalCode?: string;
}

export interface IEmergencyContact {
  name: string;
  relationship: string;
  phone: string;
}

interface IPersonalInformationData {
  status: DocumentReviewStatus;
  rejectReasonCode: string;
  taxAddress: ITaxAddress;
  emergencyContact: IEmergencyContact;
  preferredServiceAreas: IPreferredServiceAreas[];
  preferredServiceAreasForCPALL: IPreferredServiceAreasForCPALL[];
  serviceAvailableType: string;
  note: string;
  createdAt: string;
  updatedAt: string;
  documentsReviewStatus: IDocumentsReviewStatus;
  documentReviewStatus: IDocumentReviewStatus;
  editedBy: string;
  editedAt: string;
  updatedBy: string;
  approveStatus: APPROVE_STATUS;
  vendor: IVendor;
  isAllowEmergencyContact: boolean;
}

export interface IPersonalInformationResponse {
  data: IPersonalInformationData;
}

export interface IExpireDateFileResponse {
  name: string;
  s3name: string;
  folderType: string;
  createdByUser: string;
  expireDate: string;
  fileId: string;
  createdAt: string;
  updatedAt: string;
}

export interface IUpdateExpireDateRequest {
  fileId: string;
  expireDate: number;
}

export enum STATUS_RESPONSE {
  UNAUTHORIZED = 401,
}

export interface IVendor {
  staffCode: string | null;
  vendorName: string;
}
